import { Box, Checkbox, CircularProgress, Container, CssBaseline, FormControlLabel, Grid, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};


class Resoluciones extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            loading: false,
            consultaRealizada: false,
            checkAdd: false,
            resolucion: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                desde: '',
                numeroResolucion: '',
                texto: '',
                pdf: '',
            },
            consulta: {
                fecha: '',
                mes: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                numeroResolucion: '',
            },
            numeroNombre: [],
            datosConsulta: [],
            consultaEspecifica: false,
            modificar: false,
            datoEspecifico: {},
            modalBorrar: false,
            opcionSeleccionada: '',
        }

        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.resolucionAgregar = this.resolucionAgregar.bind(this);
        this.manejarEnvioAgregar = this.manejarEnvioAgregar.bind(this);
        this.manejarCambiosDatosConsulta = this.manejarCambiosDatosConsulta.bind(this);
        this.manejarConsultaEspecifica = this.manejarConsultaEspecifica.bind(this);
        this.manejarAtrasConsulta = this.manejarAtrasConsulta.bind(this);
        this.manejarAtrasEspecifica = this.manejarAtrasEspecifica.bind(this);
        this.manejarModificar = this.manejarModificar.bind(this);
        this.manejarCambiosDatosModificar = this.manejarCambiosDatosModificar.bind(this);
        this.manejarEnvioModificar = this.manejarEnvioModificar.bind(this);
        this.actList = this.actList.bind(this);
        this.manejarBorar = this.manejarBorar.bind(this);
        this.manejarCerrarModal = this.manejarCerrarModal.bind(this);
        this.manejarEnviarBorrar  = this.manejarEnviarBorrar.bind(this);
        this.manejarCambiosDatosOpciones = this.manejarCambiosDatosOpciones.bind(this);
        this.manejarCambiosDatosPDF = this.manejarCambiosDatosPDF.bind(this);
    }

    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });
    }
    render(){
        return (
            <>
                <h3>Resoluciones</h3>
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.consultaRealizada
                ?
                    null
                :
                    <FormControlLabel label='Agregar Resolución' control={<Checkbox checked={this.state.checkAdd} onChange={this.resolucionAgregar} id='add'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                }
                {this.state.consultaRealizada || (!this.state.checkAdd)
                ?
                    null
                :
                    <Box >
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item xs={4}>
                            </Grid>
                            <Grid item xs={2}>
                                <Item>Tipo de Resolución</Item>
                            </Grid>
                            <Grid item xs={2}>
                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='opcionSeleccionada'  value={this.state.opcionSeleccionada} onChange={this.manejarCambiosDatosOpciones}>
                                    <option value=''></option>
                                    <option value={1} key={1}>RESOLUCIONES SEPTIMO FUNCIONARIOS</option>
                                    <option value={2} key={2}>RESOLUCIONES SEPTIMO GENERALES</option>
                                    <option value={3} key={3}>ACTAS SEPTIMO FUNCIONARIOS</option>
                                    <option value={4} key={4}>ACTAS SEPTIMO GENERALES</option>
                                    <option value={5} key={5}>RESOLUCIONES VARIAS FUNCIONARIOS</option>
                                    <option value={6} key={6}>RESOLUCIONES VARIAS GENERALES</option>
                                </select>
                            </Grid>
                        </Grid>
                    </Box>
                }

                {this.state.opcionSeleccionada === '1'
                ?
                    <Container>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Número Funcionario</StyledTableCell>
                                        <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                        <StyledTableCell>Fecha Reolución</StyledTableCell>
                                        {/*<StyledTableCell>Tipo Resolución</StyledTableCell>*/}
                                        <StyledTableCell>Número Resolución</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.resolucion.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell>{this.state.resolucion.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.resolucion.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        {/*<StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroResolucion' value={this.state.resolucion.numeroResolucion} onChange={this.manejarCambiosDatos}/></StyledTableCell>*/}
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroResolucion' value={this.state.resolucion.numeroResolucion} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br/>
                        <input type="file" style={{border: "2px solid #D6EAF8", width: "50%"}} id='pdf' onChange={this.manejarCambiosDatosPDF} accept=".pdf"/>
                        <textarea style={{border: "2px solid #D6EAF8", width: "100%", marginTop: '1rem'}} rows={10} cols={40} id='texto' value={this.state.resolucion.texto} onChange={this.manejarCambiosDatos}/>
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioAgregar}>Agregar</button>
                    </Container>
                :
                    null
                }

                {this.state.opcionSeleccionada === '2'
                ?
                    <Container>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Fecha Reolución</StyledTableCell>
                                        {/*<StyledTableCell>Tipo Resolución</StyledTableCell>*/}
                                        <StyledTableCell>Número Resolución</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.resolucion.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        {/*<StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroResolucion' value={this.state.resolucion.numeroResolucion} onChange={this.manejarCambiosDatos}/></StyledTableCell>*/}
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroResolucion' value={this.state.resolucion.numeroResolucion} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br/>
                        <input type="file" style={{border: "2px solid #D6EAF8", width: "50%"}} id='pdf' onChange={this.manejarCambiosDatosPDF} accept=".pdf"/>
                        <textarea style={{border: "2px solid #D6EAF8", width: "100%", marginTop: '1rem'}} rows={10} cols={40} id='texto' value={this.state.resolucion.texto} onChange={this.manejarCambiosDatos}/>
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioAgregar}>Agregar</button>
                    </Container>
                :
                    null
                }

                {this.state.opcionSeleccionada === '3'
                ?
                    <Container>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Número Funcionario</StyledTableCell>
                                        <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                        <StyledTableCell>Fecha Reolución</StyledTableCell>
                                        {/*<StyledTableCell>Tipo Resolución</StyledTableCell>*/}
                                        <StyledTableCell>Número Acta</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.resolucion.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell>{this.state.resolucion.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.resolucion.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        {/*<StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroResolucion' value={this.state.resolucion.numeroResolucion} onChange={this.manejarCambiosDatos}/></StyledTableCell>*/}
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroResolucion' value={this.state.resolucion.numeroResolucion} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br/>
                        <input type="file" style={{border: "2px solid #D6EAF8", width: "50%"}} id='pdf' onChange={this.manejarCambiosDatosPDF} accept=".pdf"/>
                        <textarea style={{border: "2px solid #D6EAF8", width: "100%", marginTop: '1rem'}} rows={10} cols={40} id='texto' value={this.state.resolucion.texto} onChange={this.manejarCambiosDatos}/>
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioAgregar}>Agregar</button>
                    </Container>
                :
                    null
                }

                {this.state.opcionSeleccionada === '4'
                ?
                    <Container>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Fecha Reolución</StyledTableCell>
                                        {/*<StyledTableCell>Tipo Resolución</StyledTableCell>*/}
                                        <StyledTableCell>Número Acta</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.resolucion.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        {/*<StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroResolucion' value={this.state.resolucion.numeroResolucion} onChange={this.manejarCambiosDatos}/></StyledTableCell>*/}
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroResolucion' value={this.state.resolucion.numeroResolucion} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br/>
                        <input type="file" style={{border: "2px solid #D6EAF8", width: "50%"}} id='pdf' onChange={this.manejarCambiosDatosPDF} accept=".pdf"/>
                        <textarea style={{border: "2px solid #D6EAF8", width: "100%", marginTop: '1rem'}} rows={10} cols={40} id='texto' value={this.state.resolucion.texto} onChange={this.manejarCambiosDatos}/>
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioAgregar}>Agregar</button>
                    </Container>
                :
                    null
                }

                {this.state.opcionSeleccionada === '5'
                ?
                    <Container>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Número Funcionario</StyledTableCell>
                                        <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                        <StyledTableCell>Fecha Reolución</StyledTableCell>
                                        {/*<StyledTableCell>Tipo Resolución</StyledTableCell>*/}
                                        {/*<StyledTableCell>Número Acta</StyledTableCell>*/}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.resolucion.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell>{this.state.resolucion.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.resolucion.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        {/*<StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroResolucion' value={this.state.resolucion.numeroResolucion} onChange={this.manejarCambiosDatos}/></StyledTableCell>*/}
                                        {/*<StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroResolucion' value={this.state.resolucion.numeroResolucion} onChange={this.manejarCambiosDatos}/></StyledTableCell>*/}
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br/>
                        <input type="file" style={{border: "2px solid #D6EAF8", width: "50%"}} id='pdf' onChange={this.manejarCambiosDatosPDF} accept=".pdf"/>
                        <textarea style={{border: "2px solid #D6EAF8", width: "100%", marginTop: '1rem'}} rows={10} cols={40} id='texto' value={this.state.resolucion.texto} onChange={this.manejarCambiosDatos}/>
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioAgregar}>Agregar</button>
                    </Container>
                :
                    null
                }

                {this.state.opcionSeleccionada === '6'
                ?
                    <Container>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Fecha Reolución</StyledTableCell>
                                        {/*<StyledTableCell>Tipo Resolución</StyledTableCell>*/}
                                        {/*<StyledTableCell>Número Acta</StyledTableCell>*/}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.resolucion.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        {/*<StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroResolucion' value={this.state.resolucion.numeroResolucion} onChange={this.manejarCambiosDatos}/></StyledTableCell>*/}
                                        {/*<StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroResolucion' value={this.state.resolucion.numeroResolucion} onChange={this.manejarCambiosDatos}/></StyledTableCell>*/}
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br/>
                        <input type="file" style={{border: "2px solid #D6EAF8", width: "50%"}} id='pdf' onChange={this.manejarCambiosDatosPDF} accept=".pdf"/>
                        <textarea style={{border: "2px solid #D6EAF8", width: "100%", marginTop: '1rem'}} rows={10} cols={40} id='texto' value={this.state.resolucion.texto} onChange={this.manejarCambiosDatos}/>
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioAgregar}>Agregar</button>
                    </Container>
                :
                    null
                }

                {this.state.checkAdd || (this.state.consultaRealizada)
                ?
                    null
                :
                    <Container>
                        <Table id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Número Funcionario</StyledTableCell>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Fecha</StyledTableCell>
                                    <StyledTableCell>Mes (XXXX)</StyledTableCell>
                                    <StyledTableCell>Número Resolución</StyledTableCell>
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroFuncionario' value={this.state.consulta.numeroFuncionario} onChange={this.manejarCambiosDatosConsulta}/></StyledTableCell>
                                    <StyledTableCell>{this.state.consulta.nombreFuncionario}</StyledTableCell>
                                    <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fecha' value={this.state.consulta.fecha} onChange={this.manejarCambiosDatosConsulta}/></StyledTableCell>
                                    <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='mes' value={this.state.consulta.mes} onChange={this.manejarCambiosDatosConsulta}/></StyledTableCell>
                                    <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroResolucion' value={this.state.consulta.numeroResolucion} onChange={this.manejarCambiosDatosConsulta}/></StyledTableCell>
                                    <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Consultar</button></StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </Container>
                }
                {this.state.consultaRealizada && (!this.state.consultaEspecifica)
                ?
                    <Container>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper} >
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Número Funcionario</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell>Fecha Resolución</StyledTableCell>
                                        <StyledTableCell>Número Resolución</StyledTableCell>
                                        <StyledTableCell>Código</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {this.state.datosConsulta.map((name) => (
                                    <StyledTableRow key={name.idResoluciones}>
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.fecha.substring(8,10) + '/' + name.fecha.substring(5,7) + '/' + name.fecha.substring(0,4)}</StyledTableCell>
                                        <StyledTableCell>{name.numeroResolucion}</StyledTableCell>
                                        <StyledTableCell>{name.identificacionResolucion}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarConsultaEspecifica(name)}>Consultar</button></StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModificar(name)}>Modificar</button></StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarBorar(name)}>Borrar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <button className="btn btn-outline-success mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasConsulta}>Volver</button>
                    </Container>
                :
                    null
                }
                {this.state.consultaEspecifica
                ?
                    <Container>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Número Funcionario</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    {this.state.datoEspecifico.numeroFuncionario}
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Nombre Funcionario</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    {this.state.datoEspecifico.nombreFuncionario}
                                </Grid>
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Fecha Resolución</Item>
                                </Grid>
                                {this.state.modificar
                                ?
                                    <Grid item xs={2}>
                                        <input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fecha' value={this.state.datoEspecifico.fecha} onChange={this.manejarCambiosDatosModificar}/>
                                    </Grid>
                                :
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.fecha.substring(8,10) + '/' + this.state.datoEspecifico.fecha.substring(5,7) + '/' + this.state.datoEspecifico.fecha.substring(0,4)}
                                    </Grid>
                                }
                                <Grid item xs={2}>
                                    <Item>ID Resolución</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    {this.state.datoEspecifico.identificacionResolucion}
                                </Grid>
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Número</Item>
                                </Grid>
                                {this.state.modificar
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.numeroResolucion != '' && this.state.datoEspecifico.numeroResolucion != null ? <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroResolucion' value={this.state.datoEspecifico.numeroResolucion} onChange={this.manejarCambiosDatosModificar}/> : null}
                                    </Grid>
                                :
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.numeroResolucion}
                                    </Grid>
                                }
                            </Grid>
                        </Box>
                        <br/>
                        {(this.state.datoEspecifico.pdf != '') && (this.state.datoEspecifico != null) ? <button style={{width: "30%"}} className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.pdf)}>Descargar PDF</button> : null}
                        {this.state.modificar ? null : <textarea style={{border: "2px solid #D6EAF8", width: "100%", marginTop: '1rem'}} rows={10} cols={40} id='resolucion' value={this.state.datoEspecifico.resolucion} disabled/>}
                        {this.state.modificar ? <textarea style={{border: "2px solid #D6EAF8", width: "100%", marginTop: '1rem'}} rows={10} cols={40} id='resolucion' value={this.state.datoEspecifico.resolucion} onChange={this.manejarCambiosDatosModificar}/> : null}
                        <button className="btn btn-outline-success mx-2" style={{marginTop:'1rem'}} type='button' onClick={this.manejarAtrasEspecifica}>Volver</button>
                        {this.state.modificar ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'1rem'}} type='button' onClick={this.manejarEnvioModificar}>Enviar</button> : null}
                    </Container>
                :
                    null
                }
                {this.state.modalBorrar
                ?
                    <Modal open={this.state.modalBorrar}>
                        <Box sx={styleModal} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={3}>
                                </Grid>
                                <Grid item xs={6}>
                                    <h5> ¿Borrar Resolución? </h5>
                                </Grid>
                                <Grid item xs={3}>
                                </Grid>
                                <Grid item xs={3}>
                                </Grid>
                                <Grid item xs={2}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarCerrarModal}>Cerrar</button>
                                </Grid>
                                <Grid item xs={1}>
                                </Grid>
                                <Grid item xs={2}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnviarBorrar}>Enviar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Modal>
                :
                    null
                }
                <br/>
            </>
        )
    }

    async actList(e){
        this.setState({
            loading: true,
        })
        const cargaUtil = JSON.stringify([this.state.consulta]);

        const control = await fetch(`${Constantes.RUTA_API}/consultar_resolucion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                datosConsulta: res[1],
                consultaRealizada: true,
            })
        }
    }

    async manejoEnvioConsulta(e){
        this.setState({
            loading: true,
        })
        const cargaUtil = JSON.stringify([this.state.consulta]);

        const control = await fetch(`${Constantes.RUTA_API}/consultar_resolucion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                datosConsulta: res[1],
                consultaRealizada: true,
            })
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movimientosActualizado = state.resolucion;
            if(clave === 'numeroFuncionario'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    movimientosActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    movimientosActualizado['nombreFuncionario'] = '';
                }
                });
            }
            movimientosActualizado[clave] = valor;
            return{
                resolucion: movimientosActualizado,
            };
        })
    }

    resolucionAgregar(){
        this.setState({
            resolucion: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                desde: '',
                numeroResolucion: '',
                texto: '',
                pdf: '',
            },
        })
        if(this.state.checkAdd){
            this.setState({
                errores: false,
                notificaciones: false,
                checkAdd: false,
                opcionSeleccionada: '',
            })
        }else{
            this.setState({
                errores: false,
                notificaciones: false,
                checkAdd: true,
            })
        }
    }

    async manejarEnvioAgregar(e){
        e.preventDefault();
        this.setState({
            loading: true,
            errores: null,
            notificaciones: null,
        })

        const cargaUtil = JSON.stringify([this.state.resolucion, this.state.opcionSeleccionada]);

        const control = await fetch(`${Constantes.RUTA_API}/guardar_resolucion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Datos ingresados correctamente',
                resolucion: {
                    numeroFuncionario: '',
                    nombreFuncionario: '',
                    desde: '',
                    numeroResolucion: '',
                    texto: '',
                    pdf: '',
                },
                checkAdd: false,
                opcionSeleccionada: '',
            })
        }
    }

    manejarCambiosDatosConsulta(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movimientosActualizado = state.consulta;
            if(clave === 'numeroFuncionario'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    movimientosActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    movimientosActualizado['nombreFuncionario'] = '';
                }
                });
            }
            movimientosActualizado[clave] = valor;
            return{
                consulta: movimientosActualizado,
            };
        })
    }

    manejarConsultaEspecifica(dato){
        this.setState({
            errores: null,
            notificaciones: null,
            consultaEspecifica: true,
            datoEspecifico: dato,
        })
    }

    manejarAtrasConsulta(e){
        e.preventDefault();
        this.setState({
            notificaciones: null,
            errores: null,
            loading: false,
            consultaRealizada: false,
            checkAdd: false,
            resolucion: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                desde: '',
                numeroResolucion: '',
                texto: '',
                pdf: '',
            },
            consulta: {
                fecha: '',
                mes: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                numeroResolucion: '',
            },
            datosConsulta: [],
            consultaEspecifica: false,
            datoEspecifico: {},
            modificar: false,
        })
    }

    manejarAtrasEspecifica(e){
        e.preventDefault();
        this.setState({
            notificaciones: null,
            errores: null,
            loading: false,
            checkAdd: false,
            resolucion: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                desde: '',
                numeroResolucion: '',
                texto: '',
                pdf: '',
            },
            consultaEspecifica: false,
            datoEspecifico: {},
            modificar: false,
        })
    }

    manejarModificar(dato){
        this.setState({
            errores: null,
            notificaciones: null,
            modificar: true,
            datoEspecifico: dato,
            consultaEspecifica: true,
        })
    }

    manejarCambiosDatosModificar(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movimientosActualizado = state.datoEspecifico;
            movimientosActualizado[clave] = valor;
            return{
                datoEspecifico: movimientosActualizado,
            };
        })
    }

    async manejarEnvioModificar(e){
        e.preventDefault();
        this.setState({
            loading: true,
            errores: null,
            notificaciones: null,
        })

        const cargaUtil = JSON.stringify([this.state.datoEspecifico, sessionStorage.numeroFuncionarioAsociado]);

        const control = await fetch(`${Constantes.RUTA_API}/modificar_resolucion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.actList();
            this.setState({
                errores: null,
                notificaciones: 'Datos ingresados correctamente',
                modificar: false,
                consultaEspecifica: false,
            })
        }
    }

    manejarBorar(dato){
        this.setState({
            datoEspecifico: dato,
            errores: null,
            notificaciones: null,
            modalBorrar: true,
        })
    }

    manejarCerrarModal(e){
        e.preventDefault();
        this.setState({
            datoEspecifico: {},
            errores: null,
            notificaciones: null,
            modalBorrar: false,
        })
    }

    async manejarEnviarBorrar(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.datoEspecifico, sessionStorage.numeroFuncionarioAsociado]);

        const control = await fetch(`${Constantes.RUTA_API}/borrar_resolucion.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });

        if(res[0] === 'ok'){
            this.actList();
            this.setState({
                errores: null,
                notificaciones: 'Datos borrados correctamente',
                modalBorrar: false,
                datoEspecifico: {},
            })
        }
    }

    manejarCambiosDatosOpciones(e){
        e.preventDefault();
        //const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            opcionSeleccionada: valor,
        })
    }

    manejarCambiosDatosPDF(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor;
        valor = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (e) => {
            e.preventDefault();
            this.setState(state => {
                const movimientosActualizado = state.resolucion;
                movimientosActualizado[clave] = e.target.result;
                return{
                    resolucion: movimientosActualizado,
                };
            });
        };
    }
}

export default Resoluciones